import React from "react";
import { Tooltip } from "antd";

export type MetricTooltipKey =
  | "speed"
  | "reliability"
  | "stability"
  | "value"
  | "circulation";

export const metricTooltipDescriptions: Record<MetricTooltipKey, string> = {
  speed:
    "直近12ヶ月間のマッチング開始から完了までの「平均処理時間」をベースに、取引のスピード感を評価する指標です。",
  reliability:
    "直近12ヶ月間における「取引の完了数」をベースに、企業の信用度や取引への真摯さを評価する指標です。",
  stability:
    "直近2ヶ月間における「取引完了数」および「同一パートナーとの2回以上のリピート取引状況」から、ビジネスの継続性を評価する指標です。",
  value:
    "直近3ヶ月間のセラーの実績に基づき、「売れる商品の数」「売れる期間」「送料負担（セラー負担）設定」から、商品の商業的魅力を総合評価する指標です。",
  circulation:
    "直近12ヶ月間の「リサイクル率」「取扱カテゴリの多様性」「総商品数（流通量）」の3つの環境配慮行動から総合的に貢献度を評価する指標です。",
};

interface MetricInfoTooltipProps {
  metricKey: MetricTooltipKey;
  label: string;
  className?: string;
}

const MetricInfoTooltip = ({
  metricKey,
  label,
  className = "",
}: MetricInfoTooltipProps) => (
  <Tooltip
    title={metricTooltipDescriptions[metricKey]}
    placement="top"
    trigger={["hover", "focus"]}
    styles={{
      body: {
        maxWidth: 320,
        whiteSpace: "normal",
      },
    }}
  >
    <button
      type="button"
      aria-label={`${label}の説明`}
      className={`inline-flex h-[16px] w-[16px] shrink-0 items-center justify-center rounded-full border border-current text-[11px] font-bold leading-none text-current transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-[#d4f754]/70 ${className}`}
    >
      i
    </button>
  </Tooltip>
);

export default MetricInfoTooltip;
